// extracted by mini-css-extract-plugin
module.exports = {"col":"Header_col__1gu5P"};